var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViprSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6026 6.43711C10.1043 4.085 3.17926 1.42799 0.0290023 0.393497C-0.628443 19.6024 10.055 29.4682 15.479 32C28.9566 24.7477 32.1068 8.83279 31.9973 1.7819C31.8329 -0.423207 22.9308 -0.177318 19.9167 0.393497C17.0936 0.928152 12.3835 2.48971 10.055 3.00695L14.1641 5.53874C20.9358 2.07591 26.7377 2.40804 28.7922 3.00695C30.6988 14.3101 20.7111 24.8674 15.479 28.7332C6.73494 24.0289 3.12447 10.7112 2.41224 4.64036H3.72713C4.97628 4.83637 5.5625 7.33549 5.69947 8.56054L7.50744 5.53874C8.23063 5.14672 9.01409 5.70208 9.31541 6.02876C6.15968 17.7893 15.0681 17.9526 19.9167 16.5642C15.1174 21.2685 9.04148 16.782 6.60345 13.9508C13.5724 25.7113 22.6819 20.8557 25.7225 16.8539C24.7364 17.5889 22.5465 18.9055 21.3138 19.1777C23.9436 18.263 25.4776 15.312 25.9159 13.9508C21.3138 16.5642 18.3553 12.8619 16.5473 9.86727C14.9694 10.39 14.301 14.223 14.1641 16.0742C12.389 15.2902 12.3835 9.3228 12.6026 6.43711Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViprSmall);
export default __webpack_public_path__ + "static/media/vipr-small.eb03beec.svg";
export { ForwardRef as ReactComponent };